import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';
import { BsDatepickerConfig, DatepickerDateCustomClasses } from 'webcommon/ap-ngx-bootstrap/datepicker';
import { takeUntil } from 'rxjs/operators';
import {SystemGuid, TimeFrameDto, TimeFrameTypeDto} from 'webcommon/shared';
import { TimeFrameRepository } from 'webcommon/webapi';
import { ApBaseModalComponent } from 'webcommon/core-ui/modals-ng1520';

@Component({
  selector: 'ap-macro-editor-modal-component',
  templateUrl: './ap-timeframe-selector-modal.component.html',
  styleUrls: ['./ap-timeframe-selector-modal.component.less'],
})
export class ApTimeFrameSelectorModalComponent extends ApBaseModalComponent<TimeFrameTypeDto> implements OnInit {
  Id: string;
  baseId: string;
  patientId: string;
  timeFrameDtos: TimeFrameDto[];
  visitId: string;
  bUsePatient: boolean | null;
  aDate: Date | string | null;

  bsConfig: Partial<BsDatepickerConfig>;
  colorTheme = 'theme-emds-datepicker';

  isCalendar = false;
  isFreeText = false;
  isNumber = false;
  isDefault = false;
  canSave = false;
  selectedTimeFrame: TimeFrameDto | undefined | null;
  selectedTimeFrameId: string | undefined | null;
  selectedTimeFrameValue: any;
  title = 'Select a timeframe';
  actionTitle = 'Next';
  typeSelected = false;
  dateValue: string | null = null;
  numericValue: number | null = null;
  textValue: string | null = null;

  dateCustomClasses: DatepickerDateCustomClasses[];

  @ViewChild('numberInput') numberInput: ElementRef;
  @ViewChild('textInput') textInput: ElementRef;
  @ViewChild('dateInput') dateInput: ElementRef;

  constructor(
    elementInjector: Injector,
    private systemGuid: SystemGuid,
    private timeFrameRepository: TimeFrameRepository,
  ) {
    super(elementInjector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.setupId();
    this.bsConfig = Object.assign(
      { adaptivePosition: true },
      { containerClass: this.colorTheme },
      { dateInputFormat: 'M/D/YYYY' },
      { showWeekNumbers: false },
      { selectFromOtherMonth: true },
    );
    const now = new Date();
    this.dateCustomClasses = [
      { date: now, classes: ['emds-datepicker-current-date-background-color'] },
    ];
    const component = this;
    if (component.timeFrameDtos) {
      component.timeFrameDtos.forEach((value) => {
        component.updateDropdownTextIfNeeded(value);
      });
    } else {
      component.timeFrameDtos = [];
    }

    if (this.selectedTimeFrameId) {
      const find = this.timeFrameDtos.find((x) => x.TimeFrameId === this.selectedTimeFrameId);
      this.selectedTimeFrame = (find ? find : null);

      if (find) {
        this.typeSelected = true;
        this.onTimeFrameChange();

        if (this.selectedTimeFrameValue && this.selectedTimeFrameValue !== '') {
          this.canSave = true;
          if (this.isCalendar) {
            this.dateValue = moment(this.selectedTimeFrameValue).format('l');
          } else if (this.isFreeText) {
            this.textValue = this.selectedTimeFrameValue;
          } else if (this.isNumber) {
            this.numericValue = this.selectedTimeFrameValue;
          }
        }
      }
    } else {
      this.selectedTimeFrame = this.timeFrameDtos.find((x) => x.TimeFrameId === this.systemGuid.TimeFrame_Default);

      if (this.selectedTimeFrame) {
        this.onTimeFrameChange();
      }
    }
  }

  setupId() {
    this.Id = this.baseId + '-timeframe-selector';
  }

  private updateDropdownTextIfNeeded(stf: TimeFrameDto) {
    if (stf.TimeFrameId === this.systemGuid.TimeFrame_FreeText) {
      stf.Name = '_ free text';
    }
  }

  close() {
    this.canSave = false;
    if (this.selectedTimeFrame) {
      if (this.selectedTimeFrame.TimeFrameId === this.systemGuid.TimeFrame_Calendar && this.dateValue) {
        this.timeFrameRepository
          .getTimeFrameWithPatient(this.patientId, this.visitId, { Id: this.selectedTimeFrame.TimeFrameId, Value: this.dateValue })
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((result: TimeFrameTypeDto) => {
            super.closeModal(result);
          }, () => {
            //
          });
      } else if (this.textValue && (this.selectedTimeFrame.TimeFrameId === this.systemGuid.TimeFrame_Default ||
        this.selectedTimeFrame.TimeFrameId === this.systemGuid.TimeFrame_FreeText)) {
          this.timeFrameRepository
          .getTimeFrameWithPatient(this.patientId, this.visitId, { Id: this.selectedTimeFrame.TimeFrameId, Value: this.textValue })
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((result: TimeFrameTypeDto) => {
            super.closeModal(result);
          }, () => {
            //
          });
      } else if (this.numericValue) {
        this.timeFrameRepository
          .getTimeFrameWithPatient(this.patientId, this.visitId,
            { Id: this.selectedTimeFrame.TimeFrameId, Value: this.numericValue.toString() })
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((result: TimeFrameTypeDto) => {
            super.closeModal(result);
          }, () => {
            //
          });
      } else if (this.selectedTimeFrame.TimeFrameId === this.systemGuid.TimeFrame_Clear) {
        super.closeModal(new TimeFrameTypeDto());
      } else {
        if (!this.bUsePatient) {
          this.timeFrameRepository
            .getTimeFrameWithoutPatient(this.patientId, this.visitId,
              { Id: this.selectedTimeFrame.TimeFrameId, Value: '', BirthDate: this.aDate ? this.aDate.toString() : undefined })
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((result: TimeFrameTypeDto) => {
              super.closeModal(result);
            }, () => {
              //
            });
        } else {
          this.timeFrameRepository
            .getTimeFrameWithPatient(this.patientId, this.visitId,
              { Id: this.selectedTimeFrame.TimeFrameId, Value: '' })
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((result: TimeFrameTypeDto) => {
              super.closeModal(result);
            }, () => {
              //
            });
          }
      }
    }
  }

  filterEntry(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 45 || charCode > 57)) {
      return false;
    }

    return true;
  }

  replaceEntry(event: any) {
    event.target.value = event.target.value.replace(/\-/g, '/');
    event.target.value = event.target.value.replace(/\./g, '/');
  }

  onTimeFrameChange() {
    if (this.selectedTimeFrame) {
      if (this.selectedTimeFrame.TimeFrameId === this.systemGuid.TimeFrame_Calendar) {
        this.typeSelected = true;
        this.isCalendar = true;
        this.isFreeText = false;
        this.isNumber = false;
        this.dateValue = null;
        this.canSave = false;
        this.isDefault = false;
        setTimeout(() => {
          if (this.dateInput) {
            this.dateInput.nativeElement.focus();
          }
        }, 250);
      } else if (this.selectedTimeFrame.TimeFrameId === this.systemGuid.TimeFrame_Default ||
        this.selectedTimeFrame.TimeFrameId === this.systemGuid.TimeFrame_FreeText) {
        this.typeSelected = true;
        this.isCalendar = false;
        if (this.selectedTimeFrame.TimeFrameId === this.systemGuid.TimeFrame_Default) {
          this.isDefault = true;
          this.isFreeText = false;
        } else {
          this.isDefault = false;
          this.isFreeText = true;
        }
        this.isNumber = false;
        this.textValue = null;
        this.canSave = false;
        setTimeout(() => {
          if (this.textInput) {
            this.textInput.nativeElement.focus();
          }
        }, 250);
      } else if (this.selectedTimeFrame.Name.startsWith('_')) {
        this.typeSelected = true;
        this.isNumber = true;
        this.isCalendar = false;
        this.isFreeText = false;
        this.numericValue = null;
        this.canSave = false;
        this.isDefault = false;
        setTimeout(() => {
          if (this.numberInput) {
            this.numberInput.nativeElement.focus();
          }
        }, 250);
      } else {
        this.typeSelected = true;
        this.isNumber = false;
        this.isCalendar = false;
        this.isFreeText = false;
        this.canSave = true;
        this.isDefault = false;
      }
    } else {
      this.clearControl();
    }
  }

  onValueChange() {
    if (this.selectedTimeFrame) {
      if (this.selectedTimeFrame.TimeFrameId === this.systemGuid.TimeFrame_Calendar) {
        if (this.dateValue) {
          this.canSave = true;
        } else {
          this.canSave = false;
        }
      } else if (this.selectedTimeFrame.TimeFrameId === this.systemGuid.TimeFrame_Default ||
                 this.selectedTimeFrame.TimeFrameId === this.systemGuid.TimeFrame_FreeText) {
        if (this.textValue && this.textValue !== '') {
          this.canSave = true;
        } else {
          this.canSave = false;
        }
      } else if (this.selectedTimeFrame.Name.startsWith('_')) {
        if (this.numericValue) {
          this.canSave = true;
        } else {
          this.canSave = false;
        }
      }
    }
  }

  private clearControl() {
    this.typeSelected = false;
    this.isNumber = false;
    this.isCalendar = false;
    this.isFreeText = false;
  }

  cancel() {
    super.dismissModal();
  }
}
